import React, {useState} from 'react';
import {AutoComplete} from 'primereact/autocomplete';

import {useNavigate} from "react-router";
export const SearchMenu = () => {
    const navigate = useNavigate();
    const menu = JSON.parse(localStorage.getItem('menu'));
    const [selectedMenu, setSelectedMenu] = useState(null);
    const [filteredMenu, setFilteredMenu] = useState(null);

    const searchCountry = (event) => {
        setTimeout(() => {
            let _filteredMenus;
            if (!event.query.trim().length) {
                _filteredMenus = [...menu];
            } else {
                _filteredMenus = menu.filter((m) => {
                    return m.submenu.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredMenu(_filteredMenus);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <i className={item.icono}/>
                <div className="ml-3">{item.submenu}</div>
            </div>
        );
    }

        return (

            <AutoComplete value={selectedMenu} suggestions={filteredMenu} completeMethod={searchCountry}
                         placeholder="Buscador de menú"
                          field="name" dropdown  itemTemplate={itemTemplate}
                          onSelect={(e) => navigate(e.value?.pagina)}
                          onChange={(e) => {setSelectedMenu(e.value.submenu ? e.value?.submenu: e.value); } }/>

        );
    };


